/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { ComposedModal } from '@carbon/react';

export const _Modal = styled(ComposedModal)`
  .cds--modal-container {
    width: 768px;
    overflow-y: auto;
  }

  .cds--modal-content {
    /*
     * Needed for dropdowns inside the modal to render properly
     * See https://github.com/carbon-design-system/carbon/issues/4684#issuecomment-554090767
     */
    overflow: visible;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;
